import { render, staticRenderFns } from "./TitleLogo.vue?vue&type=template&id=dc70c2ba"
import script from "./TitleLogo.vue?vue&type=script&lang=js"
export * from "./TitleLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc70c2ba')) {
      api.createRecord('dc70c2ba', component.options)
    } else {
      api.reload('dc70c2ba', component.options)
    }
    module.hot.accept("./TitleLogo.vue?vue&type=template&id=dc70c2ba", function () {
      api.rerender('dc70c2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TitleLogo.vue"
export default component.exports